export class FloatingDefaultProps {
  public static readonly SHIP = {
    LENGTH: 120,
    BEAM: 40,
    UPPER_SHIP: 20,
    DOWN_SHIP: 20,
    DRAFT: 10,
  };

  public static readonly PLAT = {
    LENGTH: 100,
    BEAM: 100,
    HEIGHT: 50,
    DRAFT: 5,
  };
}
